const Twitter = ({ type }) => {
  const regular = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_474_586)">
        <path
          d="M15.2718 1.58667H18.083L11.9413 8.60625L19.1665 18.1583H13.5092L9.07822 12.365L4.00815 18.1583H1.19522L7.76439 10.6501L0.833191 1.58667H6.63411L10.6394 6.88195L15.2718 1.58667ZM14.2851 16.4757H15.8428L5.78769 3.18095H4.11608L14.2851 16.4757Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_474_586">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Twitter;
